export default "/assets/website/images/close-dark.svg?7ba3ea312a5f6b88d6510345f31b994b";